        document.addEventListener('DOMContentLoaded', function() {
                    const wrapper = document.querySelector('.l-footer__main__slide');
                    const slides = wrapper.querySelectorAll('.slide');
                    let current = 0;
                    let timer;

                    // 高さを揃える処理
                    function fixSlideHeight() {
                        if (window.innerWidth >= 768) {
                            wrapper.style.height = 'auto';
                            return;
                        }
                        let maxHeight = 0;
                        slides.forEach(s => {
                            maxHeight = Math.max(maxHeight, s.offsetHeight);
                        });
                        wrapper.style.height = maxHeight + 'px';
                    }

                    // スライド切替処理
                    function showSlide(index) {
                        slides.forEach((s, i) => {
                            s.classList.toggle('active', i === index);
                        });
                        fixSlideHeight();
                    }

                    // 自動再生開始
                    function startSlider() {
                        showSlide(current);
                        timer = setInterval(() => {
                            current = (current + 1) % slides.length;
                            showSlide(current);
                        }, 3000); // 3秒ごとに切替
                    }

                    // 自動再生停止
                    function stopSlider() {
                        clearInterval(timer);
                    }

                    // ブレークポイント判定
                    function checkBreakpoint() {
                        if (window.innerWidth < 768) {
                            startSlider();
                        } else {
                            stopSlider();
                            slides.forEach(s => s.classList.add('active'));
                            fixSlideHeight();
                        }
                    }

                    // 画像読み込み後に高さを再計算
                    slides.forEach(slide => {
                        const imgs = slide.querySelectorAll('img');
                        imgs.forEach(img => {
                            img.addEventListener('load', fixSlideHeight);
                        });
                    });

                    // 初期化
                    window.addEventListener('resize', checkBreakpoint);
                    window.addEventListener('load', fixSlideHeight);
                    checkBreakpoint();
                });
